export default function map() {

    const map = document.querySelector('#map');
    
    if ( map ) {
        ymaps.ready(init);

        console.log('', 
            map.dataset.coordinates.split(",")
        );
    
        function init() {
            var myMap = new ymaps.Map("map", {
                center: map.dataset.coordinates.split(","),
                zoom: map.dataset.zoom,
                controls: ['zoomControl'] // Добавляем контрол навигации
            });
            
            var myPlacemark1 = new ymaps.Placemark(map.dataset.coordinates.split(","), {
                iconContent: '',
                balloonContent: map.dataset.description,
                hintContent: map.dataset.description
            }, {
                // Указываем путь к вашей кастомной иконке
                iconLayout: 'default#image',
                iconImageHref: map.dataset.img, // Замените на реальный путь
                iconImageSize: [33, 51], // Размер иконки
                iconImageOffset: [-16, -50] // Смещение иконки
            });
    
            /* if (window.innerWidth < 768) {
                myMap.behaviors.disable(['scrollZoom', 'drag']); // Отключаем скроллинг и перетаскивание карты
            }
    
            var zoomControl = new ymaps.control.ZoomControl({
             
            });
            myMap.controls.add(zoomControl); */
    
    
            myMap.geoObjects.add(myPlacemark1);
        }
    }

    


}